import script from "./TempComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./TempComponent.vue?vue&type=script&setup=true&lang=js"

import "./TempComponent.vue?vue&type=style&index=0&id=a165cff2&scoped=true&lang=css"

import exportComponent from "/builds/sense/sense-signer/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a165cff2"]])

export default __exports__